import ApplicationSerializer from 'volta/_pods/application/serializer';


export default class SkuTaskSerializer extends ApplicationSerializer {
  modelNameFromPayloadKey(key: string) {
    if (key === 'tasks') {
      return 'sku-task';
    }
    return super.modelNameFromPayloadKey(key);
  }
}
